import api from '@/services/api.js'

// Saves the account form. /update/ returns a new token and, after a password
// change, revokes the old one (API Q-032), so the second call must use the
// new token (Q-086).
// Returns { token } on success, or { error } with the API error code.
export const saveAccount = async ({ token, shop, data }) => {
  const response = await api.updateAccount(token, shop, { ...data })
  const { error, token: newToken } = response.data

  if (error || !newToken) {
    return { error: error || 'UPDATE_FAILED' }
  }

  await api.updateMyAccount(newToken, { ...data })

  return { token: newToken }
}

// /update/ asks for the current password on a new password or a new username:
// the page sends the username on every save (API Q-146)
export const needsCurrentPassword = (loadedUsername, username, password) =>
  username !== loadedUsername || Boolean(password)

const ERROR_MESSAGES = {
  ALREADY_EXISTS: 'ERROR.ALREADY_EXISTS',
  WRONG_PASSWORD: 'ERROR.WRONG_PASSWORD',
  INVALID_EMAIL: 'ERROR.INVALID-EMAIL',
}

// The UI string key for an /update/ error code
export const accountErrorMessage = (error) =>
  ERROR_MESSAGES[error] || 'ERROR.FILL_FORM'
